// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1OUHi","icon":"style_icon__1Fdkx","title":"style_title__2QUnX"};